export const repoButton = {
    marginLeft : 2
}